import { EnabledDisabled } from '@reliance/types/enums/EnabledDisabled';
import resources from '../../resources';
export var USERS_LOADING = 'USERS/USERS_LOADING';
export var USERS_LOAD_SUCCESS = 'USERS/USERS_LOAD_SUCCESS';
export var USERS_LOAD_FAILED = 'USERS/USERS_LOAD_FAILED';
export function loadUsers() {
  return function (dispatch) {
    dispatch({
      type: USERS_LOADING
    });
    return resources.facilityUser.index({
      enabled: EnabledDisabled.ENABLED
    }).then(function (result) {
      dispatch({
        type: USERS_LOAD_SUCCESS,
        users: result
      });
    }).catch(function (err) {
      dispatch({
        type: USERS_LOAD_FAILED,
        error: err
      });
      throw err;
    });
  };
}
export var USERS_ADDING = 'USERS/USERS_ADDING';
export function addUser() {
  return function (dispatch) {
    dispatch({
      type: USERS_ADDING
    });
  };
}
export var USERS_EDITING = 'USERS/USERS_EDITING';
export function editUser(user) {
  return function (dispatch) {
    dispatch({
      type: USERS_EDITING,
      user: user
    });
  };
}
export var USERS_SAVING = 'USERS/USERS_SAVING';
export var USERS_SAVE_SUCCESS = 'USERS/USERS_SAVE_SUCCESS';
export var USERS_SAVE_FAILED = 'USERS/USERS_SAVE_FAILED';
export function createOrEditUser(user) {
  return function (dispatch) {
    dispatch({
      type: USERS_SAVING
    });
    var success = function success(response) {
      dispatch({
        type: USERS_SAVE_SUCCESS
      });
      dispatch(loadUsers());
    };
    var error = function error(err) {
      dispatch({
        type: USERS_SAVE_FAILED,
        error: err
      });
    };
    // Massage role IDs and inmate request group IDs into the format needed
    var roleIds = [];
    Object.keys(user.roleIds).forEach(function (r) {
      if (user.roleIds[r] == true) {
        roleIds.push(r.replace('role_', ''));
      }
    });
    var inmateRequestGroupIds = [];
    Object.keys(user.inmateRequestGroupIds).forEach(function (g) {
      if (user.inmateRequestGroupIds[g] == true) {
        inmateRequestGroupIds.push(g.replace('role_', ''));
      }
    });
    if (user.id != null) {
      return resources.facilityUser.put(user.id, {
        password: user.password,
        roleIds: roleIds,
        inmateRequestGroupIds: inmateRequestGroupIds
      }).then(success).catch(error);
    } else {
      return resources.facilityUser.post({
        username: user.username,
        password: user.password,
        roleIds: roleIds,
        inmateRequestGroupIds: inmateRequestGroupIds
      }).then(success).catch(error);
    }
  };
}
export var USERS_REMOVE = 'USERS/USERS_REMOVE';
export function removeUser(user) {
  return {
    type: USERS_REMOVE,
    user: user
  };
}
export var USERS_REMOVING = 'USERS/USERS_REMOVING';
export var USERS_REMOVE_SUCCESS = 'USERS/USERS_REMOVE_SUCCESS';
export var USERS_REMOVE_FAILED = 'USERS/USERS_REMOVE_FAILED';
export function removeUserSave(user) {
  return function (dispatch) {
    dispatch({
      type: USERS_REMOVING,
      user: user
    });
    return resources.facilityUser.put(user.id, {
      enabled: false
    }).then(function () {
      return dispatch({
        type: USERS_REMOVE_SUCCESS
      });
    }).then(function () {
      return dispatch(cancelOperation());
    }).then(function () {
      return dispatch(loadUsers());
    }).catch(function () {
      return dispatch({
        type: USERS_REMOVE_FAILED
      });
    });
  };
}
export var USERS_CANCEL_OPERATION = 'USERS/USERS_CANCEL_OPERATION';
export function cancelOperation() {
  return {
    type: USERS_CANCEL_OPERATION
  };
}